import { Utils } from '@pacem/pacem-core';
import { SAMPLER_BINDING_INDEX } from '../constants';
const DefaultTextureMapReferences = {
    uv: 'uv',
};
export function textureMap(references = DefaultTextureMapReferences, group, binding = SAMPLER_BINDING_INDEX) {
    const key = Utils.uniqueCode();
    const samplerReference = `sampler_${key}`;
    const texReference = `tex_${key}`;
    const ref = Utils.extend({}, DefaultTextureMapReferences, references);
    const inputColor = ref.inputColor, outputColors = ref.outputColors;
    if (Utils.isNullOrEmpty(inputColor)) {
        throw new Error('Must provide either input and output vertex color parameter names.');
    }
    const modifiers = outputColors ?
        outputColors.map((name, index) => index === 0 ? `${name} = textureSample(${texReference}, ${samplerReference}, ${ref.uv}) * ${inputColor};` : `${name} = ${outputColors[0]};`)
        : [`textureSample(${texReference}, ${samplerReference}, ${ref.uv}) * ${inputColor}`];
    return {
        // type definitions
        //definition: '',
        // bindings
        bindings: [`@group(${group}) @binding(${binding}) var ${samplerReference}: sampler;`,
            `@group(${group}) @binding(${binding + 1}) var ${texReference}: texture_2d<f32>;`],
        // modifiers
        modifiers
    };
}
